const AmazonCognitoIdentity = require('amazon-cognito-identity-js');

function AwsChangePassword(username, password, newpassword) {
  const authenticationDetails = new AmazonCognitoIdentity.AuthenticationDetails({
    Username: username,
    Password: password,
  });

  const poolData = {
    UserPoolId: process.env.VUE_APP_AWS_USER_POOL_ID, // Your user pool id here
    ClientId: process.env.VUE_APP_AWS_USER_CLIENT_ID, // Your client id here
  };

  const userPool = new AmazonCognitoIdentity.CognitoUserPool(poolData);

  const userData = {
    Username: username,
    Pool: userPool,
  };
  const cognitoUser = new AmazonCognitoIdentity.CognitoUser(userData);


  return new Promise((resolve, reject) => {
    cognitoUser.authenticateUser(authenticationDetails, {
      onSuccess() {
        cognitoUser.changePassword(password, newpassword, (err, result) => {
          if (err) {
            console.log(err);
            reject(err);
          } else {

            resolve(result);
          }
        });
      },
      onFailure(err) {
        console.log(err);

        resolve(err);
      },
    });
  });
}



export {
  AwsChangePassword as
  default,
};
